import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/mockData';
import { Gift, Users, Clock, Sparkles, Camera, Cake } from 'lucide-react';

const Anniversaire = () => {
  const [selectedFormula, setSelectedFormula] = useState('mini');
  
  const formulas = {
    mini: services.anniversaire.mini,
    deluxe: services.anniversaire.deluxe,
    luxury: services.anniversaire.luxury
  };

  const currentFormula = formulas[selectedFormula];

  return (
    <div className="page-service anniversaire-page">
      {/* Hero Header */}
      <section className="service-hero party-hero">
        <div className="service-hero-pattern" />
        <div className="service-hero-content">
          <div className="party-badge">MEYA PARTY</div>
          <h1 className="service-hero-title-party">Anniversaire</h1>
          <Gift className="hero-icon" size={60} strokeWidth={1.5} />
          <h2 className="party-subtitle">Envie d'un spa pour ton anniversaire ?</h2>
          <p className="service-hero-description">
            Atelier cosmétique, soins et shooting photo professionnel, 
            sachet de bonbons et boissons pour un anniversaire inoubliable
          </p>
          <p className="party-info">
            À domicile ou dans le local MEYA, déjà thématisé et décoré, 
            avec la présence obligatoire d'un responsable légal et d'un accompagnateur.
          </p>
        </div>
      </section>

      {/* Formula Selection */}
      <section className="formula-selection-section">
        <div className="container-service">
          <h2 className="section-title">Choisissez votre formule</h2>
          <div className="decorative-line" />
          
          <div className="formula-tabs">
            <button
              className={`formula-tab ${selectedFormula === 'mini' ? 'active' : ''}`}
              onClick={() => setSelectedFormula('mini')}
            >
              <Sparkles size={20} />
              <span>Mini Spa</span>
              <span className="formula-price">25€/pers</span>
            </button>
            <button
              className={`formula-tab ${selectedFormula === 'deluxe' ? 'active' : ''}`}
              onClick={() => setSelectedFormula('deluxe')}
            >
              <Gift size={20} />
              <span>Deluxe Spa</span>
              <span className="formula-price">50€/pers</span>
            </button>
            <button
              className={`formula-tab ${selectedFormula === 'luxury' ? 'active' : ''}`}
              onClick={() => setSelectedFormula('luxury')}
            >
              <Cake size={20} />
              <span>Luxury Spa</span>
              <span className="formula-price">90€/pers</span>
            </button>
          </div>
        </div>
      </section>

      {/* Formula Details */}
      <section className="formula-details-section">
        <div className="container-service">
          <div className="formula-card">
            <div className="formula-header">
              <h2>{currentFormula.name}</h2>
              <div className="formula-price-large">{currentFormula.price}€ <span>/personne</span></div>
            </div>

            <div className="formula-info-grid">
              <div className="formula-info-item">
                <Users size={24} />
                <div>
                  <strong>Participants</strong>
                  <p>Minimum {currentFormula.minPersons} - Maximum {currentFormula.maxPersons} personnes</p>
                </div>
              </div>
              <div className="formula-info-item">
                <Clock size={24} />
                <div>
                  <strong>Durée</strong>
                  <p>{currentFormula.duration}</p>
                </div>
              </div>
              <div className="formula-info-item">
                <Gift size={24} />
                <div>
                  <strong>Âge</strong>
                  <p>De {currentFormula.ageRange}</p>
                </div>
              </div>
              <div className="formula-info-item">
                <Sparkles size={24} />
                <div>
                  <strong>Réservation</strong>
                  <p>Acompte de {currentFormula.reservation}€</p>
                </div>
              </div>
            </div>

            <div className="formula-description">
              <h3>Formule</h3>
              <p>{currentFormula.formula}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Boxes Section */}
      <section className="boxes-section">
        <div className="container-service">
          <h2 className="section-title">Les 4 BOX au choix</h2>
          <div className="decorative-line" />
          
          <div className="boxes-grid">
            <div className="box-card">
              <div className="box-header">
                <h3>BOX SKINCARE</h3>
              </div>
              <ul className="box-list">
                {currentFormula.boxDetails.skincare.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="box-card">
              <div className="box-header">
                <h3>BOX RELAX</h3>
              </div>
              <ul className="box-list">
                {currentFormula.boxDetails.relax.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="box-card">
              <div className="box-header">
                <h3>BOX NAIL ARTIST</h3>
              </div>
              <ul className="box-list">
                {currentFormula.boxDetails.nailArtist.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="box-card">
              <div className="box-header">
                <h3>BOX GLOSSY</h3>
              </div>
              <ul className="box-list">
                {currentFormula.boxDetails.glossy.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Includes Section */}
      <section className="includes-section">
        <div className="container-service">
          <div className="includes-card">
            <h3>Inclus dans toutes les formules</h3>
            <div className="includes-grid">
              {currentFormula.includes.map((item, index) => (
                <div key={index} className="include-item">
                  <Sparkles size={20} className="include-icon" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="info-box party-info-box">
            <Camera size={32} />
            <div>
              <h4>Les photos seront remises par mail</h4>
              <p>Les cartons d'invitation sont fournis en physique</p>
              <p>Mocktail et sachet bonbon fournit</p>
              <p>Box spa offert pour tous les invités</p>
              <p className="highlight">Les ateliers sont personnalisé en fonction de la tranche d'âge</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="service-cta-content">
          <h3 className="service-cta-title">Prête pour un anniversaire magique ?</h3>
          <p className="service-cta-text">
            Réservez dès maintenant votre MEYA PARTY pour un moment inoubliable
          </p>
          <Link to="/reservation" className="btn-primary">
            Réserver maintenant
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Anniversaire;
